<div class="modal-header">
  <h6 class="modal-tilte">{{ heading }}</h6>
  <div class="header-actions">
    <button class="btn btn-sm btn-copy" (click)="copyToClipboard()">
      <i class="bi bi-clipboard"></i>Copy
    </button>
    <button type="button" class="close" aria-label="Close" (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

</div>
<div class="modal-body">
  <div *ngIf="fileType === 'text'" class="markdown-content" [innerHTML]="scriptMessage"></div>
  <pre *ngIf="fileType !== 'text'" class="line-numbers"><code [class]="'language-'+ language" #code>{{ message }}</code></pre>
</div>

<div
      class="toast-container position-fixed top-0 end-0 p-3"
      style="z-index: 1100"
    >
      <ngb-toast
        *ngFor="let toast of toastService.getToasts()"
        [autohide]="toast.options?.autohide ?? true"
        [delay]="toast.options?.delay ?? 5000"
        [class]="toast.options?.classname"
        (hidden)="toastService.remove(toast)"
      >
        <ng-template [ngIf]="toastService.isTemplate(toast)" [ngIfElse]="text">
          <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
        </ng-template>
        <ng-template #text>{{ toast.textOrTpl }}</ng-template>
      </ngb-toast>
    </div>
